import { useLayoutEffect } from 'react';
import { MonitoringGoodsProvider } from './Monitoring/MonitoringContext';

import { LayoutOrderContainer, LayoutTabSection } from './orders/_layouts/LayoutOrderContainer';

import { TabSection } from './Monitoring/TabSection';

import { SearchBar } from './Monitoring/SearchBar';
import MonitoringGoodsList from './Monitoring/MonitoringGoodsList';
import GoodsDetailPanel from './Monitoring/GoodsDetailPanel';
import { useSearchParams } from 'react-router-dom';
import useCheckMembership from '@/hooks/useCheckMembership';
import { useMonitoringGoods } from './Monitoring/MonitoringContext';
import { useNavigate } from 'react-router-dom';
import AlertDialog from '@/components/dashboard/alert-dialog';
// import MonitoringNoticeDialog from './Monitoring/MonitoringNoticeDialog';
import { ROUTES } from '@/routes';

const MonitoringPage = () => {
  return (
    <MonitoringGoodsProvider>
      <AlertDialog />
      {/* <MonitoringNoticeDialog /> */}
      <MonitoringContent />
    </MonitoringGoodsProvider>
  );
};

export default MonitoringPage;

const MonitoringContent = () => {
  const { goods, enabledMonitoringCount } = useMonitoringGoods();
  const [searchParams] = useSearchParams();
  const selectedGoodsNo = searchParams.get('select');
  const isMember = useCheckMembership();
  const fallbackMonitoringCount = isMember ? 10 : 1;
  const maxMonitoringCount = enabledMonitoringCount ?? fallbackMonitoringCount;
  const navigate = useNavigate();

  // 리스트 ↔ 상세 전환 시 스크롤 최상단으로 리셋
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    document.querySelectorAll<HTMLElement>('.scrollbar').forEach((el) => {
      el.scrollTo(0, 0);
    });
  }, [selectedGoodsNo]);

  return (
    <>
      {selectedGoodsNo ? (
        <GoodsDetailPanel />
      ) : (
        <LayoutOrderContainer className="items-center bg-gr-50 px-[60px]">
          <div className="flex w-full flex-col  bg-gr-50 pt-[40px] ">
            <div className="flex w-full  flex-col items-center justify-center">
              <TabSection />
            </div>
          </div>

          <SearchBar />
          <div className="flex h-fit w-full max-w-full flex-col   gap-[16px] bg-gr-50 py-[24px]">
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-1">
                <div className="text-gr-900 Body1S16">모니터링 상품</div>
                <div className="  Body4B14">
                  <span className="text-gr-900">{goods.length}</span>/
                  <span className="text-gr-500">{maxMonitoringCount}</span>
                </div>
              </div>
              {!isMember && (
                <button
                  type="button"
                  onClick={() => navigate(ROUTES.moreMembership)}
                  className="cursor-pointer rounded-[8px] border-none bg-[#E6EFFF] px-[10px] py-[6px] text-blue-400 Body5M14 "
                >
                  멤버십 가입하고 모니터링 상품 추가하기
                </button>
              )}
            </div>
            <MonitoringGoodsList />
          </div>
        </LayoutOrderContainer>
      )}
    </>
  );
};
